/*
 * @Author: huangyh
 * @Date: 2021-03-15 15:27:39
 * @LastEditors: huangyh
 * @LastEditTime: 2021-03-15 15:27:39
 */
/* 任意数据拷贝 */
export function deepCopy(data) {
  var target // 不能使用let 因为无法先声明在赋值
  if (!(data instanceof Object)) {
    // 返回基本类型
    return data
  } else if (data instanceof Array) {
    target = []
  } else if (data instanceof Object) {
    target = {}
  } else if (data instanceof Function) {
    // target = eval(data)
  }
  for (let key in data) {
    target[key] = deepCopy(data[key])
  }
  return target
}



// WEBPACK FOOTER //
// ./src/utils/utils.js